import { i18n } from '@lingui/core';
import { Box } from '@warp-ds/react';
import React from 'react';
import { useSearchData } from '../../data/SearchData';

type EndOfResultsProps = {
    className?: string;
};

export function EndOfPaging(props: EndOfResultsProps) {
    const { className = '' } = props;

    const { searchData } = useSearchData();

    const isEndOfPaging = searchData?.metadata?.is_end_of_paging;

    if (!isEndOfPaging) {
        return null;
    }

    return (
        <Box className={`${className} text-center s-bg-warning-subtle`}>
            <>
                <h2 className="h4">
                    {i18n.t({
                        id: 'results.end-of-paging.heading',
                        message: 'Oops! We were unable to load more ads.',
                    })}
                </h2>
                <p>
                    {i18n.t({
                        id: 'results.end-of-paging.description',
                        message: 'Narrow your search to browse more ads.',
                    })}
                </p>
            </>
        </Box>
    );
}
